var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeClosedIcon = function SvgEyeClosedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8E8E93",
    fillRule: "evenodd",
    d: "M17.354 1.354a.5.5 0 0 0-.708-.708l-14 14a.5.5 0 0 0 .708.708l2.217-2.217c1.269.526 2.746.864 4.431.864 5.673 0 8.988-3.828 9.951-5.78a.5.5 0 0 0 .014-.411c-.419-1.02-1.505-2.465-3.17-3.655-.424-.304-.889-.592-1.392-.853zM14.66 4.047l-2.215 2.215a3 3 0 0 1-4.184 4.184l-1.917 1.918a10.6 10.6 0 0 0 3.658.636c4.989 0 7.973-3.242 8.947-5.016-.399-.817-1.316-2.002-2.733-3.015a10.6 10.6 0 0 0-1.556-.922M10.002 2c1.334 0 2.547.212 3.632.562l-.848.793a10.9 10.9 0 0 0-2.784-.356C5.03 3 2.048 6.224 1.064 8c.517.934 1.585 2.266 3.203 3.32l-.75.702C1.711 10.79.556 9.246.051 8.222a.5.5 0 0 1 0-.443c.963-1.952 4.278-5.78 9.95-5.78M10 5a3 3 0 0 1 .884.133L7.08 8.69A3 3 0 0 1 10 5",
    clipRule: "evenodd"
  })));
};
export default SvgEyeClosedIcon;